module.exports = __webpack_public_path__ + "static/img/cont32_08.27cb06f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont32_08.jpg
// module id = HGi3
// module chunks = 0